<template>

  <v-container fluid>
    <v-layout row wrap justify-space-around>
      <v-flex
        shrink
        pa-1
        v-for="item in list" :key="item.id" :class="'moduleButton pointer  ' + item.id" @click="openModulItem(item)"
      >
        <v-card
          flat
          color="transparent"
          @click="openModulItem(item)"
        >
          <v-hover>
            <v-img height="107" width="251" slot-scope="{ hover }" :src="getImageUrl(item, hover)">
              <v-layout pa-2 column fill-height class="title font-weight-regular">
                <v-spacer></v-spacer>
                <v-flex shrink>
                  <span :class="'Textcolor ' + hover + 'Hover'">{{idModule.toUpperCase() + '_' + item.id.toUpperCase() + '_TITLE' | translate}}</span>
                </v-flex>
              </v-layout>
            </v-img>
          </v-hover>

        </v-card>
      </v-flex>
    </v-layout>
    <ChangelogEValueRate ref="changeLog"></ChangelogEValueRate>
  </v-container>

</template>

<script>
import Vue from 'vue'
import pgToolbar from './../Toolbar.vue'
import ChangelogEValueRate from '@/components/widgets/ChangelogEValueRate'
export default {
  name: 'Module.vue',
  components: {pgToolbar,ChangelogEValueRate},
  data () {
    return {
      idModule: '',
      list: []
    }
  },
  methods: {
    getImageUrl: function(item, hover) {
      if (!hover) {
        return 'static/' + item.id + '.png'
      }
      return 'static/' + item.id + '_hover.png'
    },
    openModulItem (item) {
      Vue.prototype.$api.debug('openModulItem', item)
      if (item.link) {
        this.$router.push('/di/' + item.link + '/' + this.idModule)
      } else {
        this.$router.push('/di/' + item.id + '/' + this.idModule)
      }
    }
  },
  mounted () {
    Vue.prototype.$api.setModule({id: this.$route.params.idModule})
    Vue.prototype.$api.debug('Module', this.$route.params.idModule)
    this.idModule = this.$route.params.idModule
    Vue.prototype.storage.resetPeergroup(Vue.prototype.$api.getModuleId())
    this.list = Vue.prototype.$api.getModuleListItems(this.idModule)
    Vue.prototype.$api.checkCredentials(this)
    Vue.prototype.$eventHub.$emit('OnGetModuleTitle', '')
    Vue.prototype.$api.getBreadCrumpModule(this.idModule)
    Vue.prototype.$eventHub.$emit('hitlistcounter', {
      hits: -1,
      totalHits: -1,
      totalHitsAppendix: ''
    })
    this.$refs.changeLog.update()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/Module.vue